// import featureIsOn from './featureIsOn';

export default function createConfigService(jokiInstance, options = {}) {
    const serviceId = options.serviceId || 'ConfigService';
    const joki = jokiInstance;
    const configs = new Map();

    if (options.defaults !== undefined && typeof options.defaults === 'object') {
        Object.keys(options.defaults).forEach(k => {
            configs.set(k, options.defaults[k]);
        });
    }

    function jokiEventHandler(event) {
        switch (event.key) {
            case 'getState':
                return configs;
            case 'getConfig':
                return configs.has(event.body) ? configs.get(event.body) : null;
            case 'setConfig':
                if (event.to === serviceId) {
                    configs.set(event.body.key, event.body.value);
                    triggerConfigUpdate();
                }
                break;
            case 'initialize':
                initializeConfigs();
                break;
            default:
                break;
        }
    }

    function initializeConfigs() {
        if (process.env.REACT_APP_FEATURES_ONLINE) configs.set('features', JSON.parse(process.env.REACT_APP_FEATURES_ONLINE));

        // Generic settings
        configs.set('defaultTimeFormatterString', 'D.M.YYYY HH:mm'); // Used by the timeFormatter function in /utils/timeFormatter.js

        configs.set('testBooleanValue', false);

        configs.set('mainAdminRole', [{ role: 'Administrator', accessScope: 'Root' }]);

        configs.set('organizationCRUDRoles', [
            { role: 'Administrator', accessScope: 'Root' },
            { role: 'Partner Admin', accessScope: 'Root' },
            { role: 'Delivery', accessScope: 'Root' },
        ]);

        configs.set('locationCRUDRoles', [
            { role: 'Administrator', accessScope: 'Root' },
            { role: 'Partner Admin', accessScope: 'Root' },
            { role: 'Delivery', accessScope: 'Root' }
        ]);

        configs.set('deviceManagementRoles', [
            { role: 'Administrator', accessScope: '' },
            { role: 'Partner Admin', accessScope: '' },
            { role: 'Delivery', accessScope: '' },
            { role: 'Cabinet Operator', accessScope: '' },
            { role: 'Industrial Operator', accessScope: '' },
        ]);

       configs.set('AlertNotificationSettingsRoles', [
           { role: 'Administrator', accessScope: ''}
        ])     
        triggerConfigUpdate();
    }

    function triggerConfigUpdate() {
        joki.serviceUpdate(serviceId, MapToObject(configs), { serviceUpdate: true });
        // joki.trigger({
        //     from: serviceId,
        //     serviceUpdate: true,
        //     body: MapToObject(configs),
        // });
    }

    function MapToObject(myMap) {
        const obj = {};
        myMap.forEach((v, k) => {
            obj[k] = v;
        });
        return obj;
    }

    joki.addService({
        id: serviceId,
        fn: jokiEventHandler,
    });
}
